import { AnalyticsEvents } from '../lib/analytics';
import { MAIN_SITE_URL } from '../lib/constants';

const headingFontFamilyStyle = { fontFamily: 'var(--font-heading)' };

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-storm text-white py-8 sm:py-12 md:py-16 px-4 sbi-shadow-xl relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-1 bg-linear-to-r from-blue via-magenta to-sunshine"></div>

      <div className="max-w-7xl xl:max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16 pb-12 border-b border-storm-400">
          <div className="p-6 rounded-xl bg-blue/20 border border-blue/40 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              SmallBiz Programs
            </h3>
            <p className="text-storm-200 text-sm mb-4">Our flagship offer. Support that compounds.</p>
            <a
              href={`${MAIN_SITE_URL}/programs`}
              onClick={() => AnalyticsEvents.footerProgramsClicked()}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Explore Programs &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Get Started
            </h3>
            <p className="text-storm-200 text-sm mb-4">Ready to grow? Start your journey here.</p>
            <a
              href={`${MAIN_SITE_URL}/get-started`}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Start Now &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Free Consults
            </h3>
            <p className="text-storm-200 text-sm mb-4">Book a free virtual strategy session.</p>
            <a
              href={`${MAIN_SITE_URL}/free-consults`}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Book Now &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Newsletter
            </h3>
            <p className="text-storm-200 text-sm mb-4">
              Get tips, insights, and updates delivered.
            </p>
            <a
              href={`${MAIN_SITE_URL}/newsletter`}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Subscribe &rarr;
            </a>
          </div>
          <div className="p-6 rounded-xl bg-storm-400/30 border border-storm-400 hover:border-sunshine/50 transition-colors group">
            <h3 className="text-xl font-bold mb-2 group-hover:text-sunshine transition-colors">
              Contact
            </h3>
            <p className="text-storm-200 text-sm mb-4">Have questions? Chat with our team.</p>
            <a
              href={`${MAIN_SITE_URL}/contact`}
              className="text-sunshine font-semibold text-sm hover:underline inline-flex items-center gap-1"
            >
              Get in Touch &rarr;
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div>
            <h4 className="font-bold text-lg mb-4" style={headingFontFamilyStyle}>
              Business Services
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={`${MAIN_SITE_URL}/programs`}
                  onClick={() => AnalyticsEvents.footerProgramsClicked()}
                  className="text-sunshine hover:text-sunshine/80 transition-colors text-sm font-semibold"
                >
                  🎯 SmallBiz Programs
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/services`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  All Services
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/on-demand-support`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  On-Demand Support
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/virtual-strategy-sessions`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Virtual Strategy Sessions
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4" style={headingFontFamilyStyle}>
              About SmallBiz
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={`${MAIN_SITE_URL}/about`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  SmallBiz Innovation
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/updates`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Company Updates
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/testimonials`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/policies`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Policies
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/faqs`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4" style={headingFontFamilyStyle}>
              Client Services
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={`${MAIN_SITE_URL}/support-desk`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  SmallBiz Support Desk
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/contact`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/free-consults`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Free Strategy Session
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4" style={headingFontFamilyStyle}>
              Resources
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={`${MAIN_SITE_URL}/blog`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/glossary`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Glossary
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/toolbox`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Toolbox
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/updates`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Updates
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/freebies`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Freebies
                </a>
              </li>
              <li>
                <a
                  href={`${MAIN_SITE_URL}/newsletter`}
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  Newsletter
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              Get In Touch
            </h4>
            <ul className="space-y-2">
              <li className="text-storm-200 text-sm font-semibold">SmallBiz Innovation LLC</li>
              <li>
                <a
                  href="mailto:hello@smallbizinnovation.com"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  hello@smallbizinnovation.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+14045475135"
                  className="text-storm-200 hover:text-sunshine transition-colors text-sm"
                >
                  (404) 547-5135
                </a>
              </li>
              <li className="text-storm-200 text-sm">Atlanta, GA</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-storm-300">
          <p>&copy; {currentYear} SmallBiz Innovation LLC. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href={`${MAIN_SITE_URL}/privacy`} className="hover:text-sunshine transition-colors">
              Privacy Policy
            </a>
            <a href={`${MAIN_SITE_URL}/terms`} className="hover:text-sunshine transition-colors">
              Terms of Service
            </a>
            <a href={`${MAIN_SITE_URL}/cookies`} className="hover:text-sunshine transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
